const checkIfType = {};

// shamelessly stolen from https://toddmotto.com/understanding-javascript-types-and-reliable-type-checking/
'Array Object String Date RegExp Function Boolean Number Null Undefined Window'
  .split(' ')
  .forEach((type) => {
    checkIfType[`is${type}`] = ((self) => (elem) => Object.prototype.toString.call(elem).slice(8, -1) === self)(type);
  });

/**
 * Recreate isNullOrUndefined, which is a legacy function that is relied on in untold places,
 * but do so with our new type-checking methods.
 * - my
 */
checkIfType.isNullOrUndefined = (value) => checkIfType.isNull(value) || checkIfType.isUndefined(value);

export default checkIfType;
